import toggleNav from './components/toggleNav';
import smoothScroll from './components/smooth-scroll';
import lazyLoadImages from './components/lazy-load-images';
import packagesSticky from './components/packages-sticky';
import mobileSlider from './utils/mobile-slider';
import floatChatBtn from './components/float-wa-chat-btn';

$(function () {
  toggleNav();
  smoothScroll();
  lazyLoadImages();
  packagesSticky();
  mobileSlider('.js-slider-sp');
  floatChatBtn();
});

$(window).on('scroll', function () {
  lazyLoadImages();
  packagesSticky();
});
